import type {
    ReviewAnswer,
    ReviewAnswerUpdateRequest,
    ReviewAnswerWithQuestionnaireResponse,
} from '@/types/review/ReviewAnswer';

import { api } from '@/api/api';

export default {
    async getReviewAnswer(id: string): Promise<ReviewAnswerWithQuestionnaireResponse> {
        const response = await api.get(`/reviewanswer/${id}`);

        return {
            ...response.data,
            isClosed: response.data?.isClosed === true,
            isEvaluationCompleted: response.data?.isEvaluationCompleted === true,
        };
    },

    async updateReviewAnswer(reviewAnswer: ReviewAnswerUpdateRequest): Promise<ReviewAnswer> {
        const response = await api.put(`/reviewanswer/${reviewAnswer.id}`, reviewAnswer);

        return response.data;
    },
};
